import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    NumberColumn,
    DateTimeColumn,
    WarningSignColumn,
  } = columns(data);

  return [
    {
      Header: 'Current BOH information',
      columns: [
        new WarningSignColumn(
          'Alert',
          'balanceOnHand',
          true,
          {
            compareLeft: 'minBohThreshold',
            compareRight: 'maxBohThreshold',
          },
        ).withWidth(55),
        new NumberColumn('Min BoH threshold', 'minBohThreshold').withWidth(100),
        new NumberColumn('Max BoH threshold', 'maxBohThreshold').withWidth(100),
        new NumberColumn('Current BoH', 'balanceOnHand').withWidth(100),
        new DateTimeColumn('Last modification date', 'lastUpdateDate').withWidth(140),
      ],
    },
  ];
};
